import { createContext, useEffect, useReducer } from "react";

import altaProtocoloPcrInitialState from "./initialStates/altaProtocoloPcrInitialState";
import ayudaInitialState from "./initialStates/ayudaInitialState";
import modalInitialState from "./initialStates/modalInitialState";
import segundoModalInitialState from "./initialStates/segundoModalInitialState";
import pacienteInitialState from "./initialStates/pacienteInitialState";
import estudioGrupoInitialState from "./initialStates/estudioGrupoInitialState";
import laboGrupoInitialState from "./initialStates/laboGrupoInitialState";
import laboTurnosInitialState from "./initialStates/laboTurnosInitialState";
import textosInitialState from "./initialStates/textosInitialState";
import mercadoPagoInitialState from "./initialStates/mercadoPagoInitialState";
import ordenEstudioInitialState from "./initialStates/ordenEstudioInitialState";
import ordenLaboratorioInitialState from "./initialStates/ordenLaboratorioInitialState";
import turnosPacienteInitialState from "./initialStates/turnosPacienteInitialState";
import selectDropDownInitialState from "./initialStates/selectDropDownState";
import estudioTurnosInitialState from "./initialStates/estudioTurnosInitialState";
import consultaMedTurnosInitialState from "./initialStates/consultaMedTurnosInitialState";
import turnosDisponiblesInitialState from "./initialStates/turnosDisponiblesInitialState";
import ordenDigitalInitialState from "./initialStates/ordenDigitalInitialState";
import labOrdenDigitalInitialState from "./initialStates/labOrdenDigitalInitialState";
import motivoCancelacionInitialState from "./initialStates/motivoCancelacionInitialState";
import cancelacionInitialState from "./initialStates/cancelacionInitialState";
import verificaDniInitialState from "./initialStates/verificaDniInitialState";
import registroInitialState from "./initialStates/registroInitialState";
import nuevoTurnoInitialState from "./initialStates/nuevoTurnoInitialState";

import altaProtocoloPcr from "./reducers/altaProtocoloPcr";
import ayuda from "./reducers/ayuda";
import modal from "./reducers/modal";
import segundoModal from "./reducers/segundoModal";
import paciente from "./reducers/paciente";
import estudioGrupo from "./reducers/estudioGrupo";
import laboGrupo from "./reducers/laboGrupo";
import laboTurnos from "./reducers/laboTurnos";
import textos from "./reducers/textos";
import mercadoPago from "./reducers/mercadoPago";
import ordenEstudio from "./reducers/ordenEstudio";
import ordenLaboratorio from "./reducers/ordenLaboratorio";
import turnosPaciente from "./reducers/turnosPaciente";
import selectDropDown from "./reducers/selectDropDown";
import estudioTurnos from "./reducers/estudioTurnos";
import consultaMedTurnos from "./reducers/consultaMedTurnos";
import turnosDisponibles from "./reducers/turnosDisponibles";
import ordenDigital from "./reducers/ordenDigital";
import labOrdenDigital from "./reducers/labOrdenDigital";
import motivoCancelacion from "./reducers/motivoCancelacion";
import cancelacion from "./reducers/cancelacion";
import verificaDni from "./reducers/verificaDni";
import registro from "./reducers/registro";
import nuevoTurno from "./reducers/nuevoTurno";

import { RESET_PORTAL_CONTEXT } from "./ActionTypes";
import { useHistory } from "react-router";
import { Network } from "@capacitor/network";

export const PortalContext = createContext();

export const PortalProvider = ({ children }) => {
  const [modalState, modalDispatch] = useReducer(modal, modalInitialState);
  const [segundoModalState, segundoModalDispatch] = useReducer(
    segundoModal,
    segundoModalInitialState,
  );
  const [registroState, registroDispatch] = useReducer(
    registro,
    registroInitialState,
  );
  const [verificaDniState, verificaDniDispatch] = useReducer(
    verificaDni,
    verificaDniInitialState,
  );
  const [pacienteState, pacienteDispatch] = useReducer(
    paciente,
    pacienteInitialState,
  );
  const [cancelacionState, cancelacionDispatch] = useReducer(
    cancelacion,
    cancelacionInitialState,
  );
  const [estudioGrupoState, estudioGrupoDispatch] = useReducer(
    estudioGrupo,
    estudioGrupoInitialState,
  );
  const [laboGrupoState, laboGrupoDispatch] = useReducer(
    laboGrupo,
    laboGrupoInitialState,
  );
  const [laboTurnosState, laboTurnosDispatch] = useReducer(
    laboTurnos,
    laboTurnosInitialState,
  );
  const [estudioTurnosState, estudioTurnosDispatch] = useReducer(
    estudioTurnos,
    estudioTurnosInitialState,
  );
  const [consultaMedTurnosState, consultaMedTurnosDispatch] = useReducer(
    consultaMedTurnos,
    consultaMedTurnosInitialState,
  );
  const [textosState, textosDispatch] = useReducer(textos, textosInitialState);
  const [turnosDisponiblesState, turnosDisponiblesDispatch] = useReducer(
    turnosDisponibles,
    turnosDisponiblesInitialState,
  );
  const [ordenEstudioState, ordenEstudioDispatch] = useReducer(
    ordenEstudio,
    ordenEstudioInitialState,
  );
  const [ordenLaboratorioState, ordenLaboratorioDispatch] = useReducer(
    ordenLaboratorio,
    ordenLaboratorioInitialState,
  );
  const [turnosPacienteState, turnosPacienteDispatch] = useReducer(
    turnosPaciente,
    turnosPacienteInitialState,
  );
  const [mercadoPagoState, mercadoPagoDispatch] = useReducer(
    mercadoPago,
    mercadoPagoInitialState,
  );
  const [motivoCancelacionState, motivoCancelacionDispatch] = useReducer(
    motivoCancelacion,
    motivoCancelacionInitialState,
  );
  const [ayudaState, ayudaDispatch] = useReducer(ayuda, ayudaInitialState);
  const [labOrdenDigitalState, labOrdenDigitalDispatch] = useReducer(
    labOrdenDigital,
    labOrdenDigitalInitialState,
  );
  const [ordenDigitalState, ordenDigitalDispatch] = useReducer(
    ordenDigital,
    ordenDigitalInitialState,
  );
  const [selectDropDownState, selectDropDownDispatch] = useReducer(
    selectDropDown,
    selectDropDownInitialState,
  );
  const [altaProtocoloPcrState, altaProtocoloPcrDispatch] = useReducer(
    altaProtocoloPcr,
    altaProtocoloPcrInitialState,
  );
  const [nuevoTurnoState, nuevoTurnoDispatch] = useReducer(
    nuevoTurno,
    nuevoTurnoInitialState,
  );

  //RESET CONTEXT
  const arrayDispatch = [
    modalDispatch,
    registroDispatch,
    pacienteDispatch,
    estudioGrupoDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    ordenEstudioDispatch,
    ordenLaboratorioDispatch,
    turnosPacienteDispatch,
    mercadoPagoDispatch,
    ayudaDispatch,
    selectDropDownDispatch,
    altaProtocoloPcrDispatch,
    segundoModalDispatch,
    nuevoTurnoDispatch,
  ];

  const sessionStorageExclusion = ["centroID"];
  const localStorageExclusion = [
    "config",
    "_cap_welcomeActive",
    "mercadoPago",
    "subidaOrden",
    "dtoSegundoFactor",
    "idTerminal",
    "dataComplete",
    "opcRecepConLlamador",
  ];

  const limpiarStorage = (sessionExcepcion, localExcepcion) => {
    //limpiar sessionStorage
    if (Object.keys(sessionStorage).length > 0) {
      Object.keys(sessionStorage).map(
        (key) =>
          !sessionExcepcion.includes(key) && sessionStorage.removeItem(key),
      );
    }
    //limpiar localStorage
    if (Object.keys(localStorage).length > 0) {
      Object.keys(localStorage).map(
        (key) => !localExcepcion.includes(key) && localStorage.removeItem(key),
      );
    }
  };

  const resetPortalContext = (index) => {
    if (Array.isArray(arrayDispatch)) {
      if (index >= arrayDispatch.length) {
        limpiarStorage(sessionStorageExclusion, localStorageExclusion);
        return;
      }
      const dispatch = arrayDispatch[index];
      dispatch({ type: RESET_PORTAL_CONTEXT });
      resetPortalContext(index + 1);
    }
  };

  const history = useHistory();
  useEffect(() => {
    const screen = window?.screen;
    if (screen) {
      let networkTimeout;

      Network.addListener("networkStatusChange", (status) => {
        if (!status.connected) {
          // Esperar 2 minutos antes de redirigir para evitar desconexiones temporales
          networkTimeout = setTimeout(() => {
            // Verificar nuevamente el estado de la red antes de redirigir
            Network.getStatus().then((currentStatus) => {
              if (!currentStatus.connected) {
                history.push("/");
              }
            });
          }, 120000); // 2 minutos = 120000 ms
        } else {
          // Si la red se restaura, cancelar el timeout
          if (networkTimeout) {
            clearTimeout(networkTimeout);
            networkTimeout = null;
          }
        }
      });

      // Cleanup function
      return () => {
        if (networkTimeout) {
          clearTimeout(networkTimeout);
        }
      };
    }
  }, []);

  return (
    <PortalContext.Provider
      value={{
        modalState,
        modalDispatch,
        registroState,
        registroDispatch,
        verificaDniState,
        verificaDniDispatch,
        pacienteState,
        pacienteDispatch,
        cancelacionState,
        cancelacionDispatch,
        estudioGrupoState,
        estudioGrupoDispatch,
        laboGrupoState,
        laboGrupoDispatch,
        laboTurnosState,
        laboTurnosDispatch,
        estudioTurnosState,
        estudioTurnosDispatch,
        consultaMedTurnosState,
        consultaMedTurnosDispatch,
        turnosDisponiblesState,
        turnosDisponiblesDispatch,
        textosState,
        textosDispatch,
        ordenEstudioState,
        ordenEstudioDispatch,
        ordenLaboratorioState,
        ordenLaboratorioDispatch,
        turnosPacienteState,
        turnosPacienteDispatch,
        mercadoPagoState,
        mercadoPagoDispatch,
        motivoCancelacionState,
        motivoCancelacionDispatch,
        ayudaState,
        ayudaDispatch,
        selectDropDownState,
        selectDropDownDispatch,
        altaProtocoloPcrState,
        altaProtocoloPcrDispatch,
        segundoModalState,
        segundoModalDispatch,
        labOrdenDigitalState,
        labOrdenDigitalDispatch,
        ordenDigitalState,
        ordenDigitalDispatch,
        nuevoTurnoState,
        nuevoTurnoDispatch,
        resetPortalContext,
      }}
    >
      {children}
    </PortalContext.Provider>
  );
};
